import * as CryptoJS from "crypto-js"

function unicode2string(unicode) {
  return eval("'" + unicode + "'");
}

var KK = '1234567890123456';
const IV = CryptoJS.enc.Utf8.parse('');
const KEY = CryptoJS.enc.Utf8.parse(KK);

var encryptWays = {
  oneEncrypt(text, keyParams, ivParams) {
    let key = KEY;
    let iv = IV;
    if (keyParams) {
      iv = CryptoJS.enc.Utf8.parse(ivParams);
      key = CryptoJS.enc.Utf8.parse(keyParams);
    }
    return CryptoJS[unicode2string('\u0052\u0061\u0062\u0062\u0069\u0074')]
      .encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode[unicode2string('\u004f\u0046\u0042')],
        padding:
          CryptoJS.pad[
            unicode2string('\u0049\u0073\u006f\u0031\u0030\u0031\u0032\u0036')
          ]
      })
      .toString();
  },
  twoEncrypt(text, keyParams, ivParams) {
    let key = KEY;
    let iv = IV;
    if (keyParams) {
      iv = CryptoJS.enc.Utf8.parse(ivParams);
      key = CryptoJS.enc.Utf8.parse(keyParams);
    }
    return CryptoJS[unicode2string('\u0044\u0045\u0053')]
      .encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode[unicode2string('\u0043\u0046\u0042')],
        padding:
          CryptoJS.pad[
            unicode2string('\u0049\u0073\u006f\u0039\u0037\u0039\u0037\u0031')
          ]
      })
      .toString();
  },
  threeEncrypt(text, keyParams, ivParams) {
    let key = KEY;
    let iv = IV;
    if (keyParams) {
      iv = CryptoJS.enc.Utf8.parse(ivParams);
      key = CryptoJS.enc.Utf8.parse(keyParams);
    }
    return CryptoJS[
      unicode2string('\u0054\u0072\u0069\u0070\u006c\u0065\u0044\u0045\u0053')
    ]
      .encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode[unicode2string('\u0043\u0054\u0052')],
        padding:
          CryptoJS.pad[
            unicode2string('\u0041\u006e\u0073\u0069\u0058\u0039\u0032\u0033')
          ]
      })
      .toString();
  },
  fourEncrypt(text, keyParams, ivParams) {
    let key = KEY;
    let iv = IV;
    if (keyParams) {
      iv = CryptoJS.enc.Utf8.parse(ivParams);
      key = CryptoJS.enc.Utf8.parse(keyParams);
    }
    return CryptoJS[unicode2string('\u0041\u0045\u0053')]
      .encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode[unicode2string('\u0045\u0043\u0042')],
        padding: CryptoJS.pad[unicode2string('\u0050\u006b\u0063\u0073\u0037')]
      })
      .toString();
  },
  fiveEncrypt(text, keyParams, ivParams) {
    let key = KEY;
    let iv = IV;
    if (keyParams) {
      iv = CryptoJS.enc.Utf8.parse(ivParams);
      key = CryptoJS.enc.Utf8.parse(keyParams);
    }
    return CryptoJS[unicode2string('\u0052\u0043\u0034')]
      .encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode[unicode2string('\u0043\u0042\u0043')],
        padding:
          CryptoJS.pad[
            unicode2string(
              '\u005a\u0065\u0072\u006f\u0050\u0061\u0064\u0064\u0069\u006e\u0067'
            )
          ]
      })
      .toString();
  },
  sixEncrypt(text, keyParams, ivParams) {
    let key = KEY;
    let iv = IV;
    if (keyParams) {
      iv = CryptoJS.enc.Utf8.parse(ivParams);
      key = CryptoJS.enc.Utf8.parse(keyParams);
    }
    return CryptoJS[
      unicode2string('\u0052\u0043\u0034\u0044\u0072\u006f\u0070')
    ]
      .encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode[unicode2string('\u0043\u0054\u0052')],
        padding:
          CryptoJS.pad[
            unicode2string(
              '\u004e\u006f\u0050\u0061\u0064\u0064\u0069\u006e\u0067'
            )
          ]
      })
      .toString();
  },
  sevenEncrypt(text, keyParams, ivParams) {
    let key = KEY;
    let iv = IV;
    if (keyParams) {
      iv = CryptoJS.enc.Utf8.parse(ivParams);
      key = CryptoJS.enc.Utf8.parse(keyParams);
    }
    return CryptoJS.AES
      .encrypt(text, key, {
        iv: iv,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Iso10126
      })
      .toString();

  },
};

export default encryptWays